function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import propTypes from 'prop-types';
import { getWindow } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { Constants } from '@shared/utils/constants';
import { useNavigate } from 'react-router';
import { getNpsModule } from '@appsource/utils/nps';
import { AppTile } from '@shared/containers/appTile';
import Ribbon from '@shared/components/ribbon';
import { loadAppPricing } from '@shared/utils/pricing';
import { getPopularItems } from '@shared/utils/filterHelpers';
import { logger } from '@src/logger';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import appsourceBanner from '@shared/images/homepage/AppSourceBanner.jpg';
import RemoteAppSourceHome from '@layout/Home';
import { generateUrlNavigation } from './Navigation';
// eslint-disable-next-line no-empty-pattern
const RemoteHome = ({}, context)=>{
    const locale = useSelector(({ config })=>config.locale);
    const pricingPayload = useSelector(({ apps })=>apps.pricingPayload);
    const unifiedExperience = useSelector(({ config })=>config.isConverged);
    const navigate = useNavigate();
    const { buildHref, loc } = context;
    const instrument = SpzaInstrumentService.getProvider();
    const handleNavigation = (options)=>{
        var _getNpsModule;
        const url = generateUrlNavigation(buildHref, options);
        if (url) {
            navigate(url);
        }
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter(Constants.NpsActions.galleryChangesCount);
        getWindow().scrollTo(0, 0);
    };
    const tilesTelemetry = (details)=>{
        const perfPayload = {
            page: getWindow() && getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.HomeApps,
            details
        };
        instrument.probe('logAndFlushTelemetryInfo', perfPayload);
        logger.info(perfPayload.details, {
            action: perfPayload.action,
            actionModifier: perfPayload.actionModifier
        });
    };
    const renderTiles = ({ carousel = false, data })=>{
        const ribbonKey = 'CuratedType_Most_Viewed_Apps';
        const ribbonTitle = loc('CuratedType_Most_Viewed_Apps');
        let popularTiles = getPopularItems({
            allItems: data
        });
        if (pricingPayload === null || pricingPayload === void 0 ? void 0 : pricingPayload.pricingData) {
            popularTiles = popularTiles.map((app)=>loadAppPricing(app, pricingPayload.pricingData));
        }
        if (popularTiles.length) {
            return /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Ribbon, {
                    carousel: carousel,
                    children: popularTiles.map((item, index)=>/*#__PURE__*/ _createElement(AppTile, _object_spread_props(_object_spread({}, item), {
                            item: item,
                            key: item.entityId,
                            tileIndex: index,
                            totalTiles: popularTiles.length,
                            onOpenTile: ()=>tilesTelemetry(`${ribbonTitle} clicked: ${item.entityId}  of: ${popularTiles.length}, with key: ${ribbonKey}`),
                            ribbonKey: ribbonKey
                        })))
                })
            });
        }
    };
    return /*#__PURE__*/ _jsx(RemoteAppSourceHome, {
        locale: locale,
        navigate: handleNavigation,
        onRenderTiles: renderTiles,
        bannerBackgroundImage: appsourceBanner,
        unifiedExperience: unifiedExperience
    });
};
RemoteHome.contextTypes = {
    buildHref: propTypes.func,
    loc: propTypes.func
};
export default RemoteHome;
